export const formatPostcodeForFirebase = (postcode: string) =>
  postcode
    .replace(/\s/g, '')
    .replace(/^(.*)(\d)/, '$1 $2')
    .toUpperCase();

export const isPostcode = (postcode: string) =>
  isFullPostcode(postcode) || isPartialPostcode(postcode);

export const isPartialPostcode = (partialPostcode: string) =>
  /^([A-Z]{1,2}[0-9][A-Z0-9]?|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA)$/i.test(
    partialPostcode,
  );

// https://en.wikipedia.org/wiki/Postcodes_in_the_United_Kingdom#Validation
export const isFullPostcode = (postcode: string) =>
  /^(([A-Z]{1,2}[0-9][A-Z0-9]?|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA) ?[0-9][A-Z]{2}|BFPO ?[0-9]{1,4}|(KY[0-9]|MSR|VG|AI)[ -]?[0-9]{4}|GE ?CX|GIR ?0A{2}|SAN ?TA1)$/i.test(
    postcode,
  );

export const isPostcodeSector = (postcode: string): boolean => {
  // ^[A-Z]{1,2} — Area: one or two uppercase letters
  // [0-9] — District: one digit
  // [0-9A-Z]? — Optional second part of the district
  // \s — Space separator between outward and inward parts
  // [0-9] — Sector: First digit of the inward code
  // $ — End of string
  const sectorRegex = /^[A-Z]{1,2}[0-9][0-9A-Z]?\s[0-9]$/;
  const sanitisedPostcode = postcode.toUpperCase();
  return sectorRegex.test(sanitisedPostcode);
};

const areaDistrictRegex =
  /^(([A-Z]{1,2})[0-9][A-Z0-9]?|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA)/i;

export const getPostcodeArea = (postcode: string) => {
  if (!isPostcode(postcode)) return;

  const match = postcode.match(areaDistrictRegex);
  if (match) {
    return match[2];
  }
};

export const getPostcodeDistrict = (postcode: string) => {
  if (!isFullPostcode(postcode)) return;

  const match = postcode.match(areaDistrictRegex);
  if (match) {
    return match[1];
  }
};

export const isScottishPostCode = (postcode?: string): boolean => {
  if (!postcode) {
    return false;
  }

  const scottishPrefixes = [
    'AB',
    'DD',
    'DG',
    'EH',
    'FK',
    'G',
    'HS',
    'IV',
    'KA',
    'KW',
    'KY',
    'ML',
    'PA',
    'PH',
    'TD',
    'ZE',
  ];

  const cleanPostcode = postcode.replace(/\s/g, '').toUpperCase();
  const ukPostcodeRegex = /^[A-Z]{1,2}[0-9][A-Z0-9]?[0-9][A-Z]{2}$/;

  if (!ukPostcodeRegex.test(cleanPostcode)) {
    return false;
  }

  const prefix = cleanPostcode.match(/^[A-Z]{1,2}/)?.[0];
  return prefix ? scottishPrefixes.includes(prefix) : false;
};
